<template>
  <div>
    <h1 class="onboarding__title mb-15">
      {{ $t('onboarding.services.title') }}
    </h1>
    <div class="onboarding__options">
      <v-btn-toggle class="onboarding__services" v-model="services">
        <v-row>
          <v-col
            v-for="item in onboardingServices"
            :key="item"
            cols="12"
            md="6"
          >
            <v-btn class="onboarding__services-item" :value="item">
              <v-row no-gutters align="center">
                <v-col cols="2">
                  <v-icon
                    :color="services === item ? 'primary' : 'grey lighten-2'"
                    small
                  >
                    mdi-check
                  </v-icon>
                </v-col>
                <v-col cols="10">
                  <p class="onboarding__services-title mb-0">
                    {{ $t(`type.${item}`) }}
                  </p>
                </v-col>
              </v-row>
            </v-btn>
          </v-col>
        </v-row>
      </v-btn-toggle>
    </div>

    <v-row class="mt-10" no-gutters>
      <v-col>
        <v-btn @click="setOnboardingStepsNavigation(1)" elevation="0" large>
          <v-icon left small> mdi-chevron-left </v-icon>
          {{ $t('onboarding.actions.previous') }}
        </v-btn>
      </v-col>
      <v-col class="text-right">
        <v-btn
          :disabled="!services || services.length <= 0"
          @click="handlePassServices"
          color="primary"
          elevation="0"
          large
        >
          {{ $t('onboarding.actions.next') }}
          <v-icon right small> mdi-chevron-right </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'OnboardingStepsServices',

  data() {
    return {
      services: '',
      predefinedServices: [
        'VISIT',
        'PHOTOGRAPHY',
        'PHOTOGRAPHY_PLUS',
        'PHOTOGRAPHY_PREMIUM_PLUS_360',
        'INSPECTION_ENTRANCE',
        'INSPECTION_EXIT',
        'INSPECTION_DELIVERY',
        'TECHNICAL_SKETCH',
      ],
    }
  },

  computed: {
    ...mapGetters(['onboardingServices']),
  },

  methods: {
    ...mapMutations([
      'setOnboardingStepsNavigation',
      'setOnboardingSelectedServices',
    ]),

    handlePassServices() {
      this.setOnboardingSelectedServices([this.services])
      this.setOnboardingStepsNavigation(3)
    },
  },
}
</script>
